import { $authHost, $host } from './index';
import {jwtDecode} from 'jwt-decode'
export const registration = async (phone_number, password) => {
  try {
    const {data} = await $host.post('/api/user/registration', { phone_number, password, role: 'USER' });
    localStorage.setItem('token', data.token)
    return jwtDecode(data.token);
  } catch (error) {
    console.error('Ошибка регистрации:', {
      status: error.response ? error.response.status : 'No response',
      data: error.response ? error.response.data : error.message,
      config: error.config,
    });
    throw error;
  }
};

export const login = async (phone_number, password) => {
  try {
    const {data} = await $host.post('/api/user/login', { phone_number, password, role: 'USER' });
    localStorage.setItem('token', data.token)
    return jwtDecode(data.token);
  } catch (error) {
    console.error('Ошибка входа:', {
      status: error.response ? error.response.status : 'No response',
      data: error.response ? error.response.data : error.message,
      config: error.config,
    });
    throw error;
  }
};

export const check = async () => {
  const { data } = await $authHost.get('/api/user/check');
  localStorage.setItem('token', data.token);
  return jwtDecode(data.token);
};